module.exports = __webpack_public_path__ + "img/agregar_tiempo.32f2e2fe.svg";